import { useEffect } from "react";
import CategoryView from "@/pages/category/components/CategoryView";

export default function CategoryMovie() {
  useEffect(() => {
    document.title = "电影分类 - 黄色影院";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "黄色影院电影分类页，汇集动作、科幻、悬疑、爱情、剧情等各类高清电影资源，支持按类型、地区、年份筛选与排序，每日更新。",
      );
    }
  }, []);

  return <CategoryView type="movie" />;
}